/**
 * マニフェストの修正/取消
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/disposal_flows`

 const disposal_flow_manifest_draft = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 登録
     * @param commit
     * @param id
     * @param params
     * @return {Promise<unknown>}
     */
    create ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}/manifest_drafts`
        Vue.$http.post(api_path, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    /**
     * 取消
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/manifest_drafts`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default disposal_flow_manifest_draft
